import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // Wait for MSAL to finish handling any redirect before deciding where to go
  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (isAuthenticated) {
    // We need to check if user can show Dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Navigate
      to="/login"
      replace
      search={{
        redirectTo: undefined,
      }}
    />
  );
}
